const stories = require('./stories')

const content = {
    getStories: function(lang){
        // const stories = [mllabelling, drilling];
        return stories.map(x=>x[lang]);
    },    
}
 
export default content;